import styled from 'styled-components';

import { Typography } from '@mui/material';

export const ConditionSummary = styled(Typography).attrs({ variant: 'caption' })`
  display: block;
  color: ${({ theme }) => theme.palette.text.secondary};
  padding-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const ConditionGroupLabel = styled.div`
  position: sticky;
  top: -8px;
  z-index: 1;
  padding-left: 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  color: ${({ theme }) => theme.palette.text.secondary};
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

const conditionRow = "[data-testid^='condition-row-']";
const conditionValueCell = "[data-testid^='condition-values-']";

export const ConditionBlock = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5, 1.5, 1.5, 5)};

  ${conditionRow} {
    grid-template-columns: minmax(0, 1.6fr) ${({ theme }) => theme.spacing(16)} minmax(0, 1fr) 32px;
    align-items: center;
  }
  ${conditionRow} .MuiInputBase-input,
  ${conditionRow} .MuiOutlinedInput-input,
  ${conditionRow} .MuiSelect-select,
  ${conditionRow} .MuiInputBase-input::placeholder {
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
  }

  ${conditionRow} .MuiOutlinedInput-root {
    height: 40px;
  }

  ${conditionValueCell} .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
  }

  @media (max-width: 1400px) {
    ${conditionRow} {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 32px;
      row-gap: ${({ theme }) => theme.spacing(1)};
    }

    ${conditionRow} > *:nth-child(1) {
      grid-column: 1 / span 2;
      grid-row: 1;
    }

    ${conditionRow} > *:nth-child(2) {
      grid-column: 1;
      grid-row: 2;
    }

    ${conditionRow} > *:nth-child(3) {
      grid-column: 2;
      grid-row: 2;
    }

    ${conditionRow} > *:nth-child(4) {
      grid-column: 3;
      grid-row: 1;
    }
  }

  @media (max-width: 900px) {
    padding-left: ${({ theme }) => theme.spacing(1.5)};

    ${conditionRow} {
      grid-template-columns: minmax(0, 1fr) 32px;
      align-items: start;
    }

    ${conditionRow} > *:nth-child(-n + 3) {
      grid-column: 1;
      grid-row: auto;
    }

    ${conditionRow} > *:nth-child(4) {
      grid-column: 2;
      grid-row: 1;
    }
  }
`;

export const ConditionError = styled(Typography).attrs({ variant: 'caption' })`
  display: block;
  padding-top: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.error.main};
`;

export const FieldRowMain = styled.div`
  display: flex;
  align-items: center;
`;

export const FieldRow = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
`;

export const FieldNameCell = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(1, 0)};
`;

export const RowControls = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-right: ${({ theme }) => theme.spacing(1)};

  > button {
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const RequiredLabel = styled(Typography).attrs({ variant: 'body2' })`
  margin: 0;
  width: ${({ theme }) => theme.spacing(17)};
`;

export const WhyControlWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing(1)};
`;

export const WhyPopoverBody = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5)};
  max-width: 280px;
`;

export const WhyPopoverText = styled(Typography).attrs({ variant: 'body2' })`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StatusBarLead = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(6, 2.5)};
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
`;

export const EmptyStateTitle = styled(Typography).attrs({ variant: 'subtitle1' })`
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const EmptyStateBody = styled(Typography).attrs({ variant: 'body2' })`
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;

export const NotAskedNote = styled(Typography).attrs({ variant: 'caption' })`
  margin-left: ${({ theme }) => theme.spacing(1)};
  font-style: italic;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
